import axios from 'axios'
import api from '@/api/api'
import state from '@/store/module_principal/state'

export default {
  buscarPlacaEmail (codUsuario, cidade, placa) {
    var info = { 
      placa: placa,
      cidade: cidade,
      codigoUsuario: codUsuario,
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/buscarPlacaEmail', token, {
      headers: {
          "content-type": "application/x-www-form-urlencoded"
      }
    }).then(result => result.data)
  },
  cadastrarEmail (usuario, cidade, alerta) {
    var info = { 
      usuario: usuario,
      cidade: cidade,
      placa: alerta.placa,
      cor: alerta.cor,
      modelo: alerta.modelo,
      nome: alerta.nome,
      empresa: alerta.empresa,
      email: alerta.email,   
      telefone: alerta.telefone,
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/cadastrarEmail', token, {
    //return axios.post("http://192.168.0.24:5004/cadastrarEmail", token, {
    
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        }
    }).then(result => result.data)
  },
  alterarEmail (codOcorrencia, usuario, cidade, alerta) {
    var info = {
      codOcorrencia: codOcorrencia, 
      usuario: usuario,
      cidade: cidade,
      id: alerta.id,
      placa: alerta.placa,
      cor: alerta.cor,
      modelo: alerta.modelo,
      nome: alerta.nome,
      empresa: alerta.empresa,
      email: alerta.email,   
      telefone: alerta.telefone,
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/alterarEmail', token, {
    //return axios.post("http://192.168.0.24:5004/alterarEmail", token, {
    
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        }
    }).then(result => result.data)
  },
  //deletarEmail (codigoUsuario, cidade, codigoEmail) {
  //  var info = { 
  //    usuario: codigoUsuario,
  //    cidade: cidade,
  //    codigoEmail: codigoEmail
  //  }
  //  var token = { token: api.aesEncrypt(JSON.stringify(info)) }
  //  return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/deletarEmail', token, {
  //  //return axios.post("http://192.168.0.24:5004/deletarEmail", token, {
  //  
  //      headers: {
  //          "content-type": "application/x-www-form-urlencoded"
  //      }
  //  }).then(result => result.data)
  //},
  buscarEmails (codigoUsuario, cidade) {
    var info = { 
      cidade: cidade,
      codigoUsuario: codigoUsuario,
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/buscarEmails', token, {
    //return axios.post("http://192.168.0.24:5004/buscarEmails", token, {
      headers: {
          "content-type": "application/x-www-form-urlencoded"
      }
    }).then(result => result.data)
  },
}